"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var reactstrap_1 = require("reactstrap");
var CalibrationResultsProps = /** @class */ (function () {
    function CalibrationResultsProps() {
        this.errors = [];
        this.warnings = [];
        this.information = [];
    }
    return CalibrationResultsProps;
}());
exports.CalibrationResultsProps = CalibrationResultsProps;
var CalibrationResults = /** @class */ (function (_super) {
    __extends(CalibrationResults, _super);
    function CalibrationResults(props) {
        return _super.call(this, props) || this;
    }
    CalibrationResults.prototype.render = function () {
        return (React.createElement("div", null,
            this.props.errors.map(function (error) {
                return React.createElement(reactstrap_1.Alert, { key: error.Description, color: "danger" }, error.Description);
            }),
            this.props.warnings.map(function (warning) {
                return React.createElement(reactstrap_1.Alert, { key: warning.Description, color: "warning" }, warning.Description);
            }),
            this.props.information.map(function (info) {
                return React.createElement(reactstrap_1.Alert, { key: info.Description, color: "info" }, info.Description);
            })));
    };
    return CalibrationResults;
}(React.Component));
exports.CalibrationResults = CalibrationResults;
//# sourceMappingURL=CalibrationResults.js.map